import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { saveFunctionBo, saveMenusBo } from './menus-new.modal';

@Injectable({
  providedIn: 'root'
})

export class MenusService {
  constructor(private http: HttpClient, public errorService: ErrorService) { }
  SaveorUpdateMenuItems(saveList: saveMenusBo): Observable<any> {
    let url = "api/SideMenuItems/saveSideMenuItems";
    return this.http.post<any>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveupdateFunction(saveList: saveFunctionBo): Observable<any> {
    let url = "api/MenuFunctionality/saveFunctionality";
    return this.http.post<number>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

}